import React from 'react';
import PropTypes from 'prop-types';
import Component from 'BaseComponent';
import autobind from 'autobind-decorator';
import makeCancelable from 'utils/makeCancelable';

export default class OperationButton extends Component {
  static propTypes = {
    label: PropTypes.array.isRequired,
    onClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
  }

  state = {
    isLoading: false,
  }

  componentWillUnmount() {
    if (this.cancelablePromise) {
      this.cancelablePromise.cancel();
    }
  }

  @autobind
  handleClick() {
    this.setState({ isLoading: true });
    this.cancelablePromise = makeCancelable(this.props.onClick());

    this.cancelablePromise
      .promise
      .then(this.handleFinished)
      .catch(this.handleFinished);
  }

  @autobind
  handleFinished(data) {
    if (!data || !data.isCanceled) {
      this.setState({ isLoading: false });
    }
    this.cancelablePromise = null;
  }

  render() {
    const { label } = this.props;
    const { isLoading } = this.state;

    return (
      <button
        className="button"
        {...this.props}
        onClick={this.handleClick}
        disabled={this.props.disabled || isLoading}
      >
        {isLoading ? 'loading...' : label}
      </button>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/OperationButton.jsx